import { Component, OnInit, ViewChild } from "@angular/core";
import { PlyrComponent } from "ngx-plyr";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { ActivatedRoute } from "@angular/router";
import CryptoJS from "crypto-js";
import { StorageService } from "../../services/storage.service";
import { AppLogo1 } from "src/app/app.config";

@Component({
  selector: "app-playvideo",
  templateUrl: "./outloginplayvideo.component.html",
  styleUrls: ["./outloginplayvideo.component.css"],
})
export class OutloginplayvideoComponent implements OnInit {
  @ViewChild(PlyrComponent) plyr: PlyrComponent;
  appLogo = AppLogo1;
  private ls = new SecureLS({ encodingType: "aes" });

  videosrc: any;
  player: Plyr;
  play_point_cut: any = [];
  videoTitle: any;
  date: any;
  currentTime: any;
  mediaPlayerEvent: any;
  transcriptionList: any;

  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    public router: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  async ngOnInit() {}

  async ngAfterViewInit() {
   
      let filter = {
        id: this.router.snapshot.queryParams.id,
      };
      let videourl: any = await this.globalService.get(
        "classVideoDetail/get/external/video-url",
        filter
      );
      if (videourl["status"] == 200) {
        this.videosrc = `/live/nfs-share${videourl["content"].video.local_file_path}${videourl["content"].video.high_file_name}`;
        this.videoTitle = videourl.content.video.video_title
          ? videourl.content.video_title
          : "No Title";
        this.date = `${videourl.content.video.start_date} ${videourl.content.start_time} UTC`;
        this.play_point_cut = videourl["content"].video_filter;
      }
  }
  onListClick(list): void {
    this.transcriptionList = list;
    this.mediaPlayerEvent.seekTime(Number(list.start), false);
    this.mediaPlayerEvent.play();
  }

  onPlayerReady(event) {
    this.mediaPlayerEvent = event;
    const role = this.storageService.getRole();
    event
      .getDefaultMedia()
      .subscriptions.loadedMetadata.subscribe(($event) => {});
    event.getDefaultMedia().subscriptions.timeUpdate.subscribe(($event) => {

        this.playing(event);
        if (Number(this.transcriptionList?.end) == event.currentTime) {
          event.pause();
        }
      this.currentTime = this.secondsToHms($event.target.currentTime);
    });
  }
  seekForward() {
    if (this.mediaPlayerEvent) {
      this.mediaPlayerEvent.currentTime += 10;  // Seek forward by 10 seconds
    }
  }
   
  seekBackward() {
    if (this.mediaPlayerEvent) {
      this.mediaPlayerEvent.currentTime -= 10;  // Seek backward by 10 seconds
    }
  } 

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);
    return (
      (h < 10 ? "0" : "") +
      h +
      ":" +
      (m < 10 ? "0" : "") +
      m +
      ":" +
      (s < 10 ? "0" : "") +
      s
    );
  }

  async playing(event) {
    for await (var duration_point of this.play_point_cut) {
      // Array of filter points
      if (
        event.currentTime >= duration_point.filter_start &&
        event.currentTime < duration_point.filter_end
      ) {
        let skip_point =
          parseFloat(duration_point.filter_end) -
          parseFloat(duration_point.filter_start);
        event.seekTime(skip_point, false);
        event.getDefaultMedia().currentTime = duration_point.filter_end;
        event.play();
      }
    }
  }
}
